export const isNumber = (value: unknown): value is number => typeof value === 'number' && !Number.isNaN(value);

export const formatInteger = (value: number): string => value.toLocaleString();

export const formatMaxOneDecimal = (value: number): string =>
  value.toLocaleString(undefined, {
    maximumFractionDigits: 1,
  });
